import {useEffect} from 'react';
import { useWeb3React } from '@web3-react/core';
import { network } from '../connectors';
import { NFTMetadata } from './NFTMetadata';
import { METADATA_RETRIEVER_HOST } from './Constants';
import { FIRST_DERIVATIVE_ADDRESS } from './Constants';

export const useEthNetwork = () => {
  const { active, library, activate } = useWeb3React("network");

  useEffect(() => {
    async function connectToWeb3Network() {
      if (!active) {
        await activate(network);
      }
    }

    connectToWeb3Network();
  }, [active, activate]);

  return [active, library];
};

export async function fetchJson<T>(request: string): Promise<T> {
  if (request.startsWith("ipfs://ipfs")) {
    request = "https://ipfs.io/ipfs" + request.substr("ipfs://ipfs".length);
  } else if (request.startsWith("ipfs://")) {
    request = "https://ipfs.io/ipfs/" + request.substr("ipfs://".length);
  }

  if (request.startsWith("https://api.artblocks.io/token")) {
    request = "https://token.artblocks.io" + request.substr("https://api.artblocks.io/token".length);
  }

  const response = await fetch(request);
  const body     = await response.json();
  return body;
}

export async function fetchDerivativeMetadata(derivativeId: string) : Promise<NFTMetadata> {
  return await fetchMetadata(FIRST_DERIVATIVE_ADDRESS, derivativeId, "721");
}

export async function fetchMetadata(contractId: string, tokenId: string, type: string) : Promise<NFTMetadata> {
  const response = await fetch(`https://${METADATA_RETRIEVER_HOST}/v1/getTokenMetadata?contractId=${contractId.toString()}&tokenId=${tokenId.toString()}&type=${type}`);
  return response.json();
}